import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PolicyLayoutProps {
  title: string;
  subtitle?: string;
  lastUpdated: string;
  children: ReactNode;
}

const PolicyLayout: React.FC<PolicyLayoutProps> = ({ title, subtitle, lastUpdated, children }) => {
  return (
    <div className="bg-gray-50">
      {/* Header */}
      <div className="bg-primary py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl font-monomakh mb-4">{title}</h1>
            {subtitle && <p className="text-xl text-gray-200">{subtitle}</p>}
          </div>
        </div>
      </div>
      
      {/* Content */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="container mx-auto px-4 py-16"
      >
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8 md:p-12">
          <div className="mb-8 pb-6 border-b border-gray-200">
            <Link to="/" className="inline-flex items-center text-primary hover:text-primary-dark transition-colors mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Torna alla Home
            </Link>
            <h2 className="text-2xl font-semibold text-primary mb-2">{title}</h2>
            <p className="text-gray-500 text-sm">Ultimo aggiornamento: {lastUpdated}</p>
          </div>
          
          <div className="prose prose-lg max-w-none prose-headings:text-primary prose-headings:font-semibold prose-h3:text-2xl prose-h3:mt-12 prose-h3:mb-6 prose-p:text-gray-600 prose-p:leading-relaxed prose-a:text-primary prose-a:no-underline hover:prose-a:underline prose-ul:text-gray-600 prose-li:my-2">
            {children}
          </div>
          
          <div className="mt-12 pt-6 border-t border-gray-200">
            <p className="text-gray-500 text-sm">
              Per domande riguardanti la nostra {title.toLowerCase()}, puoi contattarci all'indirizzo email{' '}
              <a href="mailto:privacy@molinaroimmobiliare.it" className="text-primary hover:underline">
                privacy@molinaroimmobiliare.it
              </a>{' '}
              o telefonicamente al numero <a href="tel:+393278855115" className="text-primary hover:underline">+39 327 8855115</a>.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PolicyLayout;